// TODO: Add in effect description? eg "Extra damage when unharmed"

import { BaseUnitData } from "../types";

export const baseUnitData: BaseUnitData = {
  villager: {
    unitType: "villager",
    name: "Villager",
    symbol: "🧑🏻‍🌾",
    description: "Untrained, but courageous! Terrible at fighting.",
    lockedText: "Unlocked by Town Center",
    bgImage: "bg-villager",
    bgImageSm: "bg-villagerSm",
    bgImageMd: "bg-villagerMd",
    bgImageLg: "bg-villagerLg",
    threatLevel: 0.5,
    attack: 2,
    maxHealth: 1,
    armor: 0,
    resourceCosts: { workers: 1, wood: 1, stone: 1, metal: 1 },
    buildScore: 40,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
  },
  fighter: {
    unitType: "fighter",
    name: "Fighter",
    symbol: "⚔️",
    description: "50% damage bonus at half health.",
    lockedText: "Unlocked by Swordsmithy",
    bgImage: "bg-fighter",
    bgImageSm: "bg-fighterSm",
    bgImageMd: "bg-fighterMd",
    bgImageLg: "bg-fighterLg",
    threatLevel: 1,
    attack: 5,
    maxHealth: 8,
    armor: 0,
    resourceCosts: { workers: 1, wood: 2, stone: 2 },
    buildScore: 50,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: true,
    berserkerAttackMultiplier: 1.5,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
  },
  archer: {
    unitType: "archer",
    name: "Archer",
    symbol: "🏹",
    description: "Attacks first against most unit types.",
    lockedText: "Unlocked by Archery Hut",
    bgImage: "bg-archer",
    bgImageSm: "bg-archerSm",
    bgImageMd: "bg-archerMd",
    bgImageLg: "bg-archerLg",
    threatLevel: 1.5,
    // decrease the attack but it attacks first
    attack: 4,
    maxHealth: 7,
    armor: 0,
    resourceCosts: { workers: 1, wood: 3, metal: 2 },
    buildScore: 60,
    hitsFirst: true,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
  },
  knight: {
    unitType: "knight",
    name: "Knight",
    symbol: "🛡️",
    description:
      "Uses armor to reduce incoming damage. Surviving combat increases their armor (max of 4).",
    lockedText: "Unlocked by Smelter",
    bgImage: "bg-knight",
    bgImageSm: "bg-knightSm",
    bgImageMd: "bg-knightMd",
    bgImageLg: "bg-knightLg",
    threatLevel: 1.5,
    attack: 6,
    maxHealth: 7,
    armor: 1,
    resourceCosts: { workers: 2, stone: 3, metal: 3 },
    buildScore: 80,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: true,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
  },
  // TODO: Consider allowing an armor buff for first hit, eg no damage when first hit
  mage: {
    unitType: "mage",
    name: "Mage",
    symbol: "🪄",
    description: "Magic increases their attack power while unharmed.",
    lockedText: "Unlocked by Mage School",
    bgImage: "bg-mage",
    bgImageSm: "bg-mageSm",
    bgImageMd: "bg-mageMd",
    bgImageLg: "bg-mageLg",
    threatLevel: 2,
    attack: 7,
    maxHealth: 10,
    armor: 0,
    resourceCosts: { workers: 3, stone: 3, metal: 2, crystal: 4 },
    buildScore: 120,
    hitsFirst: false,
    fullHealthBonus: true,
    fullHealthAttackBonus: 10,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
  },
  bombird: {
    unitType: "bombird",
    name: "Bombird",
    symbol: "💣",
    description:
      "Explodes on death, hugely damaging their opponent and harming up to 2 enemy army units.",
    lockedText: "Unlocked by Explosives Research",
    bgImage: "bg-bomber",
    bgImageSm: "bg-bomberSm",
    bgImageMd: "bg-bomberMd",
    bgImageLg: "bg-bomberLg",
    threatLevel: 3,
    attack: 1,
    maxHealth: 5,
    armor: 0,
    resourceCosts: { workers: 3, wood: 2, stone: 2, metal: 2, crystal: 2 },
    buildScore: 110,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: true,
    damageToOpponentOnDeath: 25,
    doesAreaOfEffectDamageOnDeath: true,
    areaOfEffectDamageOnDeath: 3,
    numberOfUnitsAffectedByAoeDamageOnDeath: 2,
  },

  // Q: what is a good name for a powerful cat-like unit in a fnatasy game that uses both fire and elemental magic to defeat their foes

  beastRider: {
    unitType: "beastRider",
    name: "Beast Rider",
    symbol: "🐲",
    description:
      "The Beast Riders are highly-skilled in melee combat. Their mount provides protection.",
    lockedText: "Unit cannot be unlocked",
    scoutWarning:
      " Also, our scouts spotted a small creature riding a large beast. The beast seemed ferocious and well-trained. Be careful!",
    bgImage: "bg-beastRider",
    bgImageSm: "bg-beastRiderSm",
    bgImageMd: "bg-beastRiderMd",
    bgImageLg: "bg-beastRiderLg",
    threatLevel: 50,
    attack: 20,
    maxHealth: 20,
    armor: 1,
    resourceCosts: { workers: 25, wood: 25, stone: 25, metal: 25, crystal: 25 },
    buildScore: 750,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: true,
    berserkerAttackMultiplier: 1.2,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
    boss: true,
  },
  uwuu: {
    unitType: "uwuu",
    name: "Uwuu",
    symbol: "🦉",
    description: "Uwuu is a wise owl who has been around for a long time. Run.",
    lockedText: "Unit cannot be unlocked",
    scoutWarning:
      ' Also, a supremely extremely powerful enemy was spotted... we heard creatures chanting "Uwuu"... be cautious!',
    bgImage: "bg-uwuu",
    bgImageSm: "bg-uwuuSm",
    bgImageMd: "bg-uwuuMd",
    bgImageLg: "bg-uwuuLg",
    threatLevel: 50,
    attack: 30,
    maxHealth: 50,
    armor: 2,
    resourceCosts: { workers: 50, wood: 50, stone: 50, metal: 50, crystal: 50 },
    buildScore: 2000,
    hitsFirst: false,
    fullHealthBonus: false,
    chargesBeforeSelection: false,
    chargingMultiplier: 1,
    berserker: false,
    survivalArmorBonus: false,
    damagesOpponentOnDeath: false,
    doesAreaOfEffectDamageOnDeath: false,
    boss: true,
  },
};

export const berserkerHealthTrigger = 0.5;
